import Vue from 'vue'
//引入加载字体
import VueI18n from 'vue-i18n'
import iView from 'iview'
import en from './en.json'
import zh_CN from './zh-CN.json'
import zh_HK from './zh-HK.json'
import km from './km'
import enLocale from 'iview/src/locale/lang/en-US'
import zhLocale from 'iview/src/locale/lang/zh-CN'
import zhTwLocale from 'iview/src/locale/lang/zh-TW'
// import kmLocale from 'iview/src/locale/lang/km'
Vue.use(VueI18n)
let messages = {
  en: { ...en, ...enLocale }, //英文
  'zh-CN': { ...zh_CN, ...zhLocale }, //中文
  'zh-HK': { ...zh_HK, ...zhTwLocale } ,//繁体
	'km':{...km}
}

class CustomFormatter {
  constructor(options) {
    this.global_values = options
  }

  interpolate(message, values) {
    // 合并全局语言参数。
    let params = { ...this.global_values, ...values }

    // 顺序替换。
    for (let key in params) {
      message = message.replace(new RegExp(':' + key, 'g'), params[key])
    }

    return [message]
  }
}

function GetQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  var r = window.location.search.substr(1).match(reg) //获取url中"?"符后的字符串并正则匹配
  var context = ''
  if (r != null) context = decodeURIComponent(r[2])
  reg = null
  r = null
  return context == null || context == '' || context == 'undefined' ? '' : context
}

var query_lang = GetQueryString('language')
const queryLang =
  query_lang === 'en' || query_lang === 'en-US'
    ? 'en'
    : query_lang === 'zh-CN'
      ? 'zh-HK'
      : query_lang === 'zh-HK' || query_lang === 'zh-TW'
        ? 'zh-HK'
        : query_lang === 'zh-CN' 
				? 'km' 
					:null

// 自动设置语言
const navLang = navigator.language
const localLang =
  navLang === 'en' || navLang === 'en-US'
    ? 'en'
    : navLang === 'zh-CN'
      ? 'zh-HK'
      : navLang === 'zh-HK' || navLang === 'zh-TW'
        ? 'zh-HK'
					: query_lang === 'zh-CN'
						? 'km'
							: false
const lang = queryLang || window.localStorage.getItem('language') || localLang || 'en'
Vue.config.lang = lang
window.localStorage.setItem('language', lang)

// 多语言配置
const i18n = new VueI18n({
  locale: Vue.config.lang,
  formatter: new CustomFormatter({
    app_name: process.env.APP_NAME
  }),
  missing: function(locale, key, vm) {
    return key
  },
  silentTranslationWarn: true,
  messages
})

Vue.use(iView, {
  i18n: (key, value) => i18n.t(key, value)
})

export default i18n



// WEBPACK FOOTER //
// ./src/lang/il8n.js